/**
 * 画像処理ユーティリティークラス
 */
class ImageUtil {
  /**
   * Imageオブジェクトへロード
   * @param {String} src イメージソース
   * @param {Object} props Imageオブジェクトに設定するproperties
   */
  async toImage(src, props) {
    return new Promise((resolve, reject) => {
      const image = new Image()
      if (props) {
        for (const [key, value] of Object.entries(props)) {
          image[key] = value
        }
      }
      image.onload = () => resolve(image)
      image.onerror = (err) => reject(err)
      image.src = src
    })
  }

  /**
   * dataURLへ変換
   * @param {CanvasImageSource} image 変換元Image
   * @param {Number} width 画像幅
   * @param {Number} height 画像高さ
   */
  toDataURL(image, width, height) {
    const canvas = document.createElement('canvas')
    canvas.width = width || image.width
    canvas.height = height || image.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0)
    const url = canvas.toDataURL()
    canvas.remove()
    return url
  }
}

export default new ImageUtil()
